import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RemoteActionService } from './logic/remote-action.service';
import { CachedFifoRemoteActionService } from './logic/cached-fifo-remote-action/cached-fifo-remote-action.service';
import { RemoteActionDaoService } from './dao/remote-action-dao.service';
import { TransmittedRemoteActionDaoService } from './dao/transmitted-remote-action-dao.service';
import { RemoteActionDbDaoService } from './dao/remote-action-db-dao/remote-action-db-dao.service';
import { TransmittedRemoteActionDbDaoService } from './dao/transmitted-remote-action-db-dao/transmitted-remote-action-db-dao.service';
import { TransmittedRemoteActionDbTableDefinition } from './dao/transmitted-remote-action-db-dao/transmitted-remote-action-db-table-definition';
import { RemoteActionDbTableDefinition } from './dao/remote-action-db-dao/remote-action-db-table-definition';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    { provide: RemoteActionService, useClass: CachedFifoRemoteActionService },
    {
      provide: RemoteActionDaoService,
      useClass: RemoteActionDbDaoService
    },
    {
      provide: TransmittedRemoteActionDaoService,
      useClass: TransmittedRemoteActionDbDaoService
    },
    { provide: TransmittedRemoteActionDbTableDefinition },
    { provide: RemoteActionDbTableDefinition },
  ]
})
export class RemoteActionModule {}
